
import { UserRole } from "@/hooks/useUserRoles";
import UserRoleItem from "./UserRoleItem";
import { useAuth } from "@/context/AuthContext";

interface UserWithRoles {
  id: string;
  email: string;
  roles: UserRole[];
}

interface UsersListProps {
  users: UserWithRoles[];
  onAddRole: (user: UserWithRoles) => void;
  onRemoveRole: (userId: string, role: UserRole) => void;
}

const UsersList = ({ users, onAddRole, onRemoveRole }: UsersListProps) => {
  const { user: currentUser } = useAuth();
  
  if (users.length === 0) {
    return (
      <div className="text-center p-4 text-muted-foreground">
        Clique em "Carregar Usuários e Funções" para visualizar e gerenciar funções de usuários
      </div>
    );
  }

  return (
    <div className="border rounded-lg divide-y">
      {users.map(user => (
        <UserRoleItem 
          key={user.id} 
          user={user} 
          onAddRole={onAddRole} 
          onRemoveRole={onRemoveRole}
          isCurrentUser={user.id === currentUser?.id}
        />
      ))}
    </div>
  );
};

export default UsersList;
